export default __webpack_public_path__ + "static/media/doc2-icon.8b0a3394.svg";